import { createContext, useContext } from 'react';
import { CustomerContentType } from '../types/types';

export const initialValue: CustomerContentType = {
  revenueInvoices: [],
  customerBalanceHistory: [],
  customerInfo: undefined,
  affiliatedProducts: [],
  fundsRequests: [],
  toggleMenu: () => {},
  navigateDesktop: () => {},
  mobileMenu: false,
  shopId: null,
  shopInfo: null,
  refetchCustomerInfo: () => {}
}

const CustomerContext = createContext(initialValue);

export const useCustomerContext = () => useContext(CustomerContext) as CustomerContentType;

export default CustomerContext;
